
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/legacy/show_priv_key",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/legacy/show_priv_key/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/legacy/show_priv_key"])
      });
    }
  